import React from "react";
import PropTypes from "prop-types";
import TipCarousel from "./tip-carousel";
import LoaderGif from "../../assets/images/smart-mark-loader.gif";
import MarketingReachResults from "./marketing-reach-results";
import TrailingIcon from "./icons/trailing-icon";
import externalLinks from "../constants/externalLinks";

// Add a delay to the loading state to ensure the loading spinner is visible for a minimum time
// const MIN_LOADING_TIME_MS = 3000;
const SPINNER_TIPS = [
  {
    key: "tip-1",
    title: "Train Your Team for Better Email Collection",
    description: "Staff who actively request emails and marketing consent help grow your marketing reach effortlessly.",
  },
  {
    key: "tip-2",
    title: "Enable POS Sign-Ups for Easy Opt-Ins",
    description: "Turn on the POS Email Marketing Sign-up Screen so customers can opt in at checkout—no extra steps needed!",
  },
  {
    key: "tip-3",
    title: "Offer Incentives to Boost Sign-Ups",
    description: "Give customers a reason to share their email—exclusive discounts, offers, or loyalty perks work wonders!",
  },
];

const EstimatedMarketingReachSetup = ({
  isLoading = false,
  isError = false,
  onNext = () => { },
  data = {
    customersChecked: 0,
    emailCount: 0,
  }
}) => {
  const sampleSize = data?.customersChecked ?? 0
  const customersWithEmail = data?.emailCount ?? 0;
  const percentageWithEmail = sampleSize > 0 ? Math.round((customersWithEmail / sampleSize) * 100) : 0;
  const percentageWithoutEmail = sampleSize > 0 ? 100 - percentageWithEmail : 0;

  if (isLoading) {
    return (
      <div className="estimated-marketing-reach flex flex-col justify-between">
        {/* Spacer */}
        <div />

        <div className="marketing-reach-content-loading">
          <img src={LoaderGif} className="mailchimp-loading" alt="Loading" />
          <h1>Estimated marketing reach....</h1>
          <p>Before the full sync, we’ll analyze a sample of up to 500 customers to estimate your marketing reach and help you understand your email marketing potential.</p>
        </div>

        <div className="flex items-center justify-center">
          <TipCarousel tips={SPINNER_TIPS} />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="estimated-marketing-reach-loading flex flex-col justify-between">
        <div className="marketing-reach-content">
          <h1>Something went wrong, please try again...</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="estimated-marketing-reach flex flex-col justify-between">
      <div className="marketing-reach-content">
        <div>
          <div className="title-container">
            <h2 className="title">Nice Going!</h2>
            <p className="tagline">We’ve analyzed a sample of up to {sampleSize} customers, and we estimate we can sync <strong>{percentageWithEmail}%</strong>!</p>
          </div>
        </div>
        <MarketingReachResults
          sampleSize={sampleSize}
          customersWithEmail={customersWithEmail}
          percentageWithEmail={percentageWithEmail}
          percentageWithoutEmail={percentageWithoutEmail}
        />
        <div className="footer-container">
          <div className="footnote-container">
            <h3 className="footnote">Want to get more email subscribers on your point of sale?</h3>
            <button type="button" className="wink-button wink-button-primary" onClick={onNext}>Continue to choose audience</button>
          </div>
          <div>
            <a
              className="learn-more"
              href={externalLinks.LEARN_MORE_URL}
              target="_blank"
              rel="noreferrer"
            >
              <span>Learn more about enabling email collection</span>
              <TrailingIcon size={24} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

EstimatedMarketingReachSetup.propTypes = {
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  data: PropTypes.shape({
    customersChecked: PropTypes.number,
    emailCount: PropTypes.number,
  }),
  onNext: PropTypes.func,
};

export default EstimatedMarketingReachSetup;
